import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

export const TermsOfDeliverySection = () => {
  const t = useTranslations();
  return (
    <>
      <TypographyV3 Element="h2" variant="h1">
        {t('terms_delivery_title')}
      </TypographyV3>
      <TypographyV3>
        <em>{t('terms_delivery_last_updated')}</em>
      </TypographyV3>

      <TypographyV3 Element="h3" variant="h3">
        {t('terms_delivery_subtitle_canada_uk')}
      </TypographyV3>
      <TypographyV3>{t('terms_delivery_p_canada_uk')}</TypographyV3>

      <TypographyV3 Element="h3" variant="h3">
        {t('terms_delivery_subtitle_eu_usa')}
      </TypographyV3>
      <TypographyV3>{t('terms_delivery_p_eu_usa')}</TypographyV3>

      <TypographyV3 Element="h3" variant="h3">
        {t('terms_delivery_subtitle_outside')}
      </TypographyV3>
      <TypographyV3>{t('terms_delivery_p_outside')}</TypographyV3>
    </>
  );
};
